import React from 'react';
import { RotateCcw, Check, Sparkles, FileText, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function ImagePreview({
  imageSrc,
  sourceType = 'camera',
  onRetake,
  onConfirmImage,
  onManualEntry
}) {
  return (
    <div className="relative w-full rounded-2xl overflow-hidden bg-stone-950 border border-stone-800 shadow-2xl flex flex-col items-center">
      {/* Top Header */}
      <div className="w-full z-20 px-5 py-3.5 bg-stone-900/90 backdrop-blur-md flex items-center justify-between border-b border-stone-800 text-stone-200">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-emerald-400" />
          <span className="text-xs font-semibold tracking-wide uppercase text-stone-300">
            Preview Prescription Image
          </span>
        </div>

        <span className="text-xs px-2.5 py-1 rounded-full bg-stone-800 text-stone-400 border border-stone-700/60">
          Source: {sourceType === 'camera' ? 'Camera Capture' : 'Device Upload'}
        </span>
      </div>

      {/* Image Preview Surface */}
      <div className="relative w-full max-h-[65vh] bg-stone-900 flex items-center justify-center overflow-hidden p-4">
        <img
          src={imageSrc}
          alt="Prescription capture preview"
          className="max-h-[60vh] w-auto max-w-full rounded-lg shadow-lg object-contain border border-stone-800"
        />
      </div>

      {/* Instructions / Guidance */}
      <div className="w-full bg-stone-900/60 px-6 py-2.5 border-t border-stone-800/80 text-center">
        <p className="text-xs text-stone-400">
          Ensure the <strong className="text-stone-200 font-medium">Patient Name</strong> is sharp and clearly readable before proceeding.
        </p>
      </div>

      {/* Action Buttons Bar */}
      <div className="w-full bg-stone-900 px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-stone-800">
        <Button
          type="button"
          variant="outline"
          onClick={onRetake}
          className="w-full sm:w-auto border-stone-700 bg-stone-800 text-stone-200 hover:bg-stone-700 hover:text-white flex items-center justify-center gap-2 h-11 px-5"
        >
          <RotateCcw className="h-4 w-4" />
          <span>Retake / Change Image</span>
        </Button>

        <div className="flex items-center gap-3 w-full sm:w-auto">
          <Button
            type="button"
            onClick={onConfirmImage}
            className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-500 text-white font-medium flex items-center justify-center gap-2 h-11 px-6 shadow-md transition-all active:scale-95"
          >
            <Check className="h-4 w-4" />
            <span>Use This Image (Run OCR)</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
